export default __webpack_public_path__ + "static/media/private_communities.416ce565.svg";